import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import { apis } from '../api/index.js';
import './user.css';
import TableEmpty from '../components/TableEmpty.js';
import { message, Form, Select, Checkbox, ConfigProvider, Icon } from 'antd';
import { Button, Table, Input, Popover, Pagination, Breadcrumb } from 'antd';
import { DatePicker } from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import throttle from 'lodash.throttle';
import { changeListWidth, getProvinceOption, getDay } from '../utils';
import { getProjectOption, instProjectInfo, breadItem } from '../utils';
import { showMoreSearch, setScrollTop, loadingOptions } from '../utils';
import { getParams, formatFromTime, formatToTime } from '../utils';
import { fastDateOption, calcTableHeight } from '../utils';
import { getInstitutionOptions } from '../utils';

const { Option } = Select;
const CheckboxGroup = Checkbox.Group;

class UserBehavior extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listWidth: 'calc(87% - 8px)',
      institutionData: [],
      eventList: [],
      status: '',
      searchLoading: true,
      timeTypeVal: false,
      projectList: [],
      provinceList: [],
      checkedList: [],
      total: 0,
      pageNum: 1,
      pageSize: 20,
      recentDays: 2,
      dayRange: [getDay(-2) + ' 0:0:0', getDay(0) + ' 23:59:59'],
      searchValue: {
        projectId: null,
        productionId: null,
        userName: null,
        areaProvince: null,
        userType: null,
        chromeVersion: null,
        sr: null,
        installType: null,
        pageId: null,
        terminal: null,
        pageSource: null,
        elementId: null,
        respCode: null,
      },
      searchOption: {},
    };

    this.throttledUserList = throttle(searchValue => {
      setScrollTop();
      this.getPageEvent(searchValue);
    }, 1000);

    this.formResize = throttle(newState => {
      //滚动条重置到顶部
      const newHeight = calcTableHeight(200) || 0;
      const showMore = showMoreSearch();
      this.setState({ showMoreFilter: showMore, tableHeight: newHeight });
    }, 1000);
  }

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    form: PropTypes.object,
    setPrevPage: PropTypes.func,
    setUserBehaviorTable: PropTypes.func,
  };

  componentDidMount() {
    this.getInstitutionData();
    const { timeTypeVal } = this.state;
    if (timeTypeVal) {
      const { dayRange } = this.state;
      this.timeOnChange(dayRange);
    } else {
      const { recentDays } = this.state;
      this.timeCalc(recentDays);
    }
    const post = { pageNum: 1, pageSize: 20 };
    setTimeout(() => this.throttledUserList(post), 10);

    window.addEventListener('resize', () => this.formResize());
    this.formResize();
    this.getInstProjectInfo();
    this.getProvinceList();
    this.getUserTypes();

    const head = this.props.user.behaviorTable || [];
    this.setState({ checkedList: head });
  }
  //获取项目列表
  getInstProjectInfo = async () => {
    const res = await instProjectInfo();
    this.setState({ projectList: res.list });
  };
  // 获取省份列表
  getProvinceList = () => {
    apis.getArea(0).then(res => {
      if (res.code === '0') this.setState({ provinceList: res.data });
    });
  };
  getUserTypes = () => {
    apis.userTypes().then(res => {
      if (res.code === '0') this.setState({ userTypeList: res.data });
    });
    apis.pageEventSearch().then(res => {
      if (res.code === '0') this.setState({ searchOption: res.data });
    });
  };
  getPageEvent = searchValue => {
    const data = {
      fromTime: this.state.fromTime,
      toTime: this.state.toTime,
      pageNum: this.state.pageNum,
      pageSize: 20,
    };
    const post = { ...searchValue, ...data };
    apis.pageEventList(post).then(res => {
      this.setState({ searchLoading: false });
      if (res.code === '0') {
        this.setState({ eventList: res.data.list, total: res.data.total });
      } else if (res.code === '1009') {
        this.props.setPrevPage(this.props.history.location.pathname);
        this.props.history.push('/login');
      }
    });
  };

  //获取机构列表
  getInstitutionData = name => {
    const post = { institutionName: name };
    apis.institutionRecord(post).then(result => {
      if (result.code === '0') {
        this.setState({ institutionData: result.data });
      } else if (result.code === '1009') {
        message.error(result.message);
        this.props.setPrevPage(this.props.history.location.pathname);
        this.props.history.push('/login');
      } else {
        this.setState({ institutionData: [] });
      }
    });
  };

  //点击重置按钮
  handleReset = () => {
    const searchValue = {
      projectId: null,
      productionId: null,
      userName: null,
      areaProvince: null,
      userType: null,
      chromeVersion: null,
      sr: null,
      installType: null,
      pageId: null,
      terminal: null,
      pageSource: null,
      elementId: null,
      respCode: null,
    };
    this.setState({
      tableHeight: 0,
      moreFilter: true,
      showMoreFilter: false,
      timeTypeVal: false,
      recentDays: 2,
      dayRange: [getDay(-2) + ' 0:0:0', getDay(0) + ' 23:59:59'],
      searchValue,
    });
    this.timeCalc(2);
    this.props.form.resetFields();
    setTimeout(() => this.throttledUserList(searchValue), 10);
  };

  getColumns = () => {
    const columns = [];
    const { checkedList } = this.state;
    columns.push(
      {
        title: '产品名称',
        dataIndex: 'productionName',
        key: 'productionName',
        width: 150,
      },
      { title: '当前页面', dataIndex: 'pageName', key: 'pageName', width: 100 },
      { title: '页面来源', dataIndex: 'pageSource', key: 'source', width: 100 },
      { title: '操作描述', dataIndex: 'elementName', key: 'name', width: 150 },
      { title: '操作结果', dataIndex: 'respMsg', key: 'respMsg', width: 100 },
      {
        title: '操作时间',
        dataIndex: 'eventTime',
        key: 'eventTime',
        width: 150,
        sorter: true,
        sortDirections: ['ascend', 'descend'],
      },
      { title: '操作用户', dataIndex: 'userName', key: 'userName', width: 100 },
      { title: '用户IP', dataIndex: 'terminalIp', key: 'ip', width: 120 },
      { title: '用户类型', dataIndex: 'userType', key: 'userType' }
    );
    if (checkedList.indexOf('机构') > -1)
      columns.push({
        title: '所属机构',
        dataIndex: 'instName',
        key: 'inst',
        width: 150,
      });

    if (checkedList.indexOf('终端') > -1)
      columns.push({
        title: '终端',
        dataIndex: 'terminal',
        key: 'terminal',
        width: 150,
      });

    if (checkedList.indexOf('部署方式') > -1)
      columns.push({
        title: '部署方式',
        dataIndex: 'installType',
        key: 'installType',
        width: 150,
      });

    if (checkedList.indexOf('屏幕分辨率') > -1)
      columns.push({
        title: '屏幕分辨率',
        dataIndex: 'sr',
        key: 'sr',
        width: 150,
      });

    if (checkedList.indexOf('浏览器版本') > -1)
      columns.push({
        title: '浏览器版本',
        dataIndex: 'chromeVersion',
        key: 'chromeVersion',
        width: 150,
      });
    return columns;
  };

  handleSearch = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const searchValue = {
          projectId: values.projectId,
          productionId: values.productionId,
          userName: values.userName,
          areaProvince: values.areaProvince,
          userType: values.userType,
          chromeVersion: values.chromeVersion,
          sr: values.sr,
          installType: values.installType,
          pageId: values.pageId,
          terminal: values.terminal,
          pageSource: values.pageSource,
          elementId: values.elementId,
          respCode: values.respCode,
          instIds: values.institution,
        };
        this.setState({ searchValue, pageNum: 1 });
        setTimeout(() => this.throttledUserList(searchValue), 10);
      }
    });
  };
  setTimeType = e => {
    if (e.target.checked) {
      const { dayRange } = this.state;
      this.timeOnChange(dayRange);
    } else {
      const { recentDays } = this.state;
      this.timeCalc(recentDays);
    }
    this.setState({ timeTypeVal: e.target.checked });
  };
  timeOnChange = value => {
    let fromTime = formatFromTime(value);
    let toTime = formatToTime(value);
    this.setState({ fromTime, toTime, dayRange: value });
  };
  timeCalc = value => {
    let [fromTime, toTime] = [undefined, undefined];
    if (value !== undefined) {
      fromTime = getDay(-value) + ' 0:0:0';
      toTime = getDay(0) + ' 23:59:59';
    }

    this.setState({ fromTime, toTime, recentDays: value });
  };

  //获取用户类型下拉列表
  getUserTypesOptions = () => {
    const { userTypeList } = this.state;
    if (userTypeList) {
      const options = userTypeList.map(item => (
        <Option key={item.id}>{item.userType}</Option>
      ));
      return options;
    }
  };

  checkboxOnChange = e => {
    this.setState({ checkedList: e });
    this.props.setUserBehaviorTable(e);
  };

  pageOnChange = pageNum => {
    this.setState({ pageNum });
    const { searchValue } = this.state;
    setTimeout(() => this.throttledUserList(searchValue), 10);
  };

  download = () => {
    const post = { ...this.state.searchValue };
    post.fromTime = this.state.fromTime;
    post.toTime = this.state.toTime;
    const search = getParams(post);
    const url = `/ai-web/pageEvent/logExcel`;
    let xhr = new XMLHttpRequest();
    xhr.open('POST', url, true); //url填写后台的接口地址
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    let fileName = `数据埋点.xlsx`;
    xhr.responseType = 'blob';
    const _this = this;
    xhr.onload = function(oEvent) {
      _this.setState({ isLoading: false });
      if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
        //校验是否下载参数
        let content = xhr.response;

        //数据转换为文件下载
        let elink = document.createElement('a');
        elink.download = fileName || 'demo.xlsx';
        elink.style.display = 'none';
        let blob = new Blob([content]);
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      }
    };

    xhr.send(search);
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { eventList, timeTypeVal, searchOption } = this.state;
    const { institutionData } = this.state;
    const { recentDays, provinceList, checkedList, dayRange } = this.state;
    const { moreFilter, showMoreFilter, total, tableHeight } = this.state;
    const columns = this.getColumns();
    const plainOptions = [
      '机构',
      '终端',
      '部署方式',
      '屏幕分辨率',
      '浏览器版本',
    ];
    const menu = (
      <CheckboxGroup
        options={plainOptions}
        value={this.state.checkedList}
        onChange={e => this.checkboxOnChange(e)}
      />
    );
    let tableWidth = 1150;
    const len = checkedList.length;
    tableWidth += len * 150;
    const screenWidth = document.body.clientWidth * 0.87 - 55;
    if (screenWidth > tableWidth) tableWidth = screenWidth;
    const browser = searchOption.chromeVersion || [];
    const pageList = searchOption.page || [];
    const sr = searchOption.sr || [];
    const product = searchOption.product || [];

    const from = formatFromTime(dayRange);
    const to = formatToTime(dayRange);
    const style5 = { width: 240 };

    const style1 = { display: timeTypeVal === true ? '' : 'none' };
    const style2 = { display: timeTypeVal === true ? 'none' : '' };
    const dateFormat = 'YYYY-MM-DD';
    const { RangePicker } = DatePicker;
    return (
      <div className="form-bg">
        <ConnectedMenu toggleCollapsed={changeListWidth.bind(this, this)} />
        <div className="theme-content">
          <ConnectedHeader
            toggleCollapsed={changeListWidth.bind(this, this)}
            login={false}
            home={true}
          />
          <div className="theme-box">
            <div className="bread-crumb">
              <Breadcrumb>{breadItem(['系统管理', '用户行为'])}</Breadcrumb>
            </div>
            <div
              className="box theme-userbehavior"
              style={{ width: this.state.listWidth }}
            >
              <div className="left">
                <Form
                  className={`ant-advanced-search-form${
                    !moreFilter && showMoreFilter ? ' notOverflow' : ''
                  }`}
                  onSubmit={this.handleSearch}
                  layout="inline"
                  style={{ maxHeight: '115px' }}
                >
                  <div className="searchBox">
                    <div className="searchBoxContent">
                      <div className="search-unit">
                        <Form.Item
                          style={style1}
                          label="上传时间"
                          colon={false}
                        >
                          <ConfigProvider locale={zh_CN}>
                            {getFieldDecorator('dayRange', {
                              initialValue:
                                from && to
                                  ? [
                                      moment(from, dateFormat),
                                      moment(to, dateFormat),
                                    ]
                                  : null,
                            })(
                              <RangePicker
                                format={dateFormat}
                                placeholder={['开始时间', '结束时间']}
                                style={style5}
                                onChange={value => {
                                  this.timeOnChange(value);
                                }}
                              />
                            )}
                          </ConfigProvider>
                        </Form.Item>
                        <Form.Item
                          style={style2}
                          label="上传时间"
                          colon={false}
                        >
                          {getFieldDecorator('recentDays', {
                            initialValue: recentDays,
                          })(
                            <Select
                              defaultActiveFirstOption={true}
                              showArrow={false}
                              filterOption={false}
                              allowClear={true}
                              style={style5}
                              onChange={value => this.timeCalc(value)}
                            >
                              {fastDateOption()}
                            </Select>
                          )}
                        </Form.Item>
                        <Form.Item label="" colon={false}>
                          {getFieldDecorator('defineTimeType', {})(
                            <Checkbox
                              checked={timeTypeVal}
                              onChange={this.setTimeType}
                            >
                              自定义
                            </Checkbox>
                          )}
                        </Form.Item>
                      </div>
                      <Form.Item label="机构" colon={false}>
                        {getFieldDecorator('institution', {})(
                          <Select
                            placeholder="全部"
                            defaultActiveFirstOption={false}
                            allowClear={true}
                            style={style5}
                          >
                            {getInstitutionOptions(institutionData, 'id')}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="项目名称" colon={false}>
                        {getFieldDecorator('projectId', {})(
                          <Select
                            allowClear={true}
                            placeholder="选择项目名称"
                            style={{ width: 160 }}
                          >
                            {getProjectOption(this.state.projectList)}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="产品名称" colon={false}>
                        {getFieldDecorator('productionId', {})(
                          <Select
                            allowClear={true}
                            placeholder="全部"
                            style={{ width: 160 }}
                          >
                            {product.map((item, index) => (
                              <Option value={item.code} key={index}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="操作用户" colon={false}>
                        {getFieldDecorator('userName', {})(
                          <Input
                            type="text"
                            allowClear={true}
                            placeholder="全部"
                            style={{ width: 160 }}
                          />
                        )}
                      </Form.Item>
                      <Form.Item label="机构区域" colon={false}>
                        {getFieldDecorator('areaProvince', {})(
                          <Select
                            allowClear={true}
                            placeholder="全部"
                            style={{ width: 160 }}
                          >
                            {getProvinceOption(provinceList)}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="用户类型" colon={false}>
                        {getFieldDecorator('userType', {})(
                          <Select
                            allowClear={true}
                            placeholder="全部"
                            style={{ width: 160 }}
                          >
                            {this.getUserTypesOptions()}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="浏览器版本" colon={false}>
                        {getFieldDecorator('chromeVersion', {})(
                          <Select
                            allowClear={true}
                            placeholder="全部"
                            style={{ width: 160 }}
                          >
                            {browser.map((item, index) => (
                              <Option value={item} key={index}>
                                {item}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="屏幕分辨率" colon={false}>
                        {getFieldDecorator('sr', {})(
                          <Select
                            allowClear={true}
                            placeholder="全部"
                            style={{ width: 160 }}
                          >
                            {sr.map((item, index) => (
                              <Option value={item} key={index}>
                                {item}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="部署方式" colon={false}>
                        {getFieldDecorator('installType', {})(
                          <Select
                            allowClear={true}
                            placeholder="全部"
                            style={{ width: 160 }}
                          >
                            <Option value="C">云部署</Option>
                            <Option value="P">私有化部署</Option>
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="当前页面" colon={false}>
                        {getFieldDecorator('pageId', {})(
                          <Select
                            allowClear={true}
                            placeholder="全部"
                            style={{ width: 160 }}
                          >
                            {pageList.map((item, index) => (
                              <Option value={item.code} key={index}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="终端" colon={false}>
                        {getFieldDecorator('terminal', {})(
                          <Select
                            allowClear={true}
                            placeholder="全部"
                            style={{ width: 160 }}
                          >
                            <Option value="1">客户端</Option>
                            <Option value="2">浏览器</Option>
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="页面来源" colon={false}>
                        {getFieldDecorator('pageSource', {})(
                          <Select
                            allowClear={true}
                            placeholder="全部"
                            style={{ width: 160 }}
                          >
                            {pageList.map((item, index) => (
                              <Option value={item.code} key={index}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="操作描述" colon={false}>
                        {getFieldDecorator('elementId', {})(
                          <Input
                            type="text"
                            allowClear={true}
                            placeholder="全部"
                            style={{ width: 160 }}
                          />
                        )}
                      </Form.Item>
                      <Form.Item label="操作结果" colon={false}>
                        {getFieldDecorator('respCode', {})(
                          <Select
                            allowClear={true}
                            placeholder="全部"
                            style={{ width: 160 }}
                          >
                            <Option value="0">成功</Option>
                            <Option value="1">失败</Option>
                          </Select>
                        )}
                      </Form.Item>
                    </div>
                  </div>
                  <div className="searchOptBox">
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="btn-search"
                        disabled={this.state.searchLoading}
                      >
                        {this.state.loadingIconShow ? (
                          <Icon type="sync" spin />
                        ) : (
                          <Icon type="search" />
                        )}
                        搜索
                      </Button>
                      <Button
                        style={{ marginLeft: 8 }}
                        icon="redo"
                        className="btn-reset"
                        disabled={this.state.searchLoading}
                        onClick={this.handleReset}
                      >
                        重置
                      </Button>
                    </Form.Item>
                    {showMoreFilter && (
                      <Button
                        type="link"
                        className="moreFilter"
                        onClick={() => {
                          this.setState({ moreFilter: !moreFilter });
                        }}
                        icon={moreFilter ? 'down' : 'up'}
                      >
                        {moreFilter ? '展开' : '收起'}
                      </Button>
                    )}
                  </div>
                  <div className="setting-btns">
                    <Button onClick={() => this.download()}>导出全部</Button>
                    <Popover placement="bottom" content={menu} trigger="click">
                      <Button icon="plus">更多表头</Button>
                    </Popover>
                  </div>
                </Form>
                <div className="history-list">
                  <Table
                    loading={loadingOptions(this.state.searchLoading)}
                    columns={columns}
                    dataSource={eventList}
                    defaultExpandAllRows={true}
                    expandedRowRender={record => (
                      <p>记录内容：{record.prms || '--'}</p>
                    )}
                    rowKey={(record, index) => index}
                    key={(record, index) => index}
                    className="list-item"
                    rowClassName={record => (record.prms ? 'prms' : 'no-prms')}
                    scroll={{ y: tableHeight, x: tableWidth }}
                    locale={{ emptyText: <TableEmpty /> }}
                    pagination={false}
                    onChange={(pagination, filters, sorter) => {
                      const orderType = { descend: 'DESC', ascend: 'ASC' };
                      const sortType = orderType[sorter.order];
                      const orderField = sorter.columnKey || '';
                      const newState = {
                        pageNum: 1,
                        sortBy: orderField,
                        sort: sortType,
                        searchLoading: true,
                      };
                      this.throttledUserList(newState);
                    }}
                  />
                  <ConfigProvider locale={zh_CN}>
                    <Pagination
                      onChange={this.pageOnChange}
                      total={this.state.total}
                      pageSize={20}
                      className="list-page"
                      current={this.state.pageNum}
                      showQuickJumper
                      size="small"
                      showTotal={() => `共${total}条`}
                    />
                  </ConfigProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Form.create()(UserBehavior));
